module.exports = __webpack_public_path__ + "img/AlexanderMiller_140x140_rund.a2d52556.jpg";